import { motion } from "framer-motion";
import NavigationColored from './../components/NavigationColored';
import serviceImage from './../../assets/images/services/meeting-room.jpg';

const pageVariants = {
    initial: { scale: 0.9, opacity: 0 },
    in: { scale: 1, opacity: 1 },
    out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
    type: "tween",
    ease: "easeInOut",
    duration: 0.5,
};

const MeetingRoom = () => {
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
        >
            <NavigationColored />
            <div style={{ marginTop: '4em' }}></div>
            <section className="service">
                <div className="container">
                    <div className="section-title" style={{ marginBottom: "50px" }}>
                        <h1>Meeting Room</h1>
                        <p>“Smart Spaces for Smart Meetings.”</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <p align="justify">A meeting room is a large space designed for events, conferences, and group gatherings. Equipped with state-of-the-art audio-visual technology, high-speed internet, and customizable seating arrangements, our meeting rooms are perfect for brainstorming sessions, client meetings, training workshops, and strategy discussions. The professional setting helps set the right tone for productive conversations, while support services such as on-demand catering, technical assistance, and reception handling ensure a seamless experience. Whether you’re meeting with internal teams or hosting important guests, our meeting rooms offer a polished and practical environment tailored to your business needs.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 sub-services">
                            {/* <ul>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
                            </ul> */}
                            <img className="service-image" src={serviceImage} alt="service Image"/>
                        </div>
                    </div>
                </div>
            </section>
        </motion.div>
    )
}

export default MeetingRoom
